import type { IWatermarkElement } from '@/types/watermarks.types';
import type { ElementRefs } from '../watermark.types';
import { getDomMatrixFromStyles, matrixRotationInDegrees, matrixScale } from './matrix-utils';

export const withUpdatedWatermarkDimensions =
  (selectedElement: IWatermarkElement | undefined, elementRefs: ElementRefs) => (el: IWatermarkElement) => {
    if (el.uuid === selectedElement?.uuid) {
      const htmlEl = elementRefs.current.get(selectedElement.uuid);
      if (!htmlEl) return el;

      const transform = getDomMatrixFromStyles(htmlEl);
      return {
        ...el,
        settings: {
          ...el.settings,
          dimensions: {
            ...el.settings.dimensions,
            x: Math.round(transform.e),
            y: Math.round(transform.f),
            rotation: Math.round(matrixRotationInDegrees(transform)),
            scale: matrixScale(transform),
          },
        },
      };
    }
    return el;
  };
